import { render } from "./BookingCreationView.vue?vue&type=template&id=f4db113a&scoped=true&ts=true"
import script from "./BookingCreationView.vue?vue&type=script&lang=ts"
export * from "./BookingCreationView.vue?vue&type=script&lang=ts"

import "./BookingCreationView.vue?vue&type=style&index=0&id=f4db113a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4db113a"]])

export default __exports__